import { Box, Flex, Text, Collapse, IconButton, Badge } from "@chakra-ui/react";
import { FaChevronDown, FaChevronUp, FaEdit, FaEye, FaEyeSlash, FaPlus } from "react-icons/fa";
import { memo, useState } from "react";
import PropertyList from "./PropertyList";

const problemCount = (category) =>
    category.properties.reduce(
        (sum, property) => sum + property.entries.filter((entry) => entry.isProblem && entry.isActive).length,
        0
    );

const CategoryList = ({ categories, onEdit, onDeactivate }) => {
    const [openCategories, setOpenCategories] = useState({});

    const toggleCategory = (categoryId, event) => {
        if (event.target.closest(".edit-icon, .deactivate-icon, .add-icon")) return;
        setOpenCategories((prev) => ({
            ...prev,
            [categoryId]: !prev[categoryId],
        }));
    };

    return (
        <>
            {categories.length > 0 ? (
                categories.map((category) => {
                    const count = problemCount(category);
                    return (
                        <Box
                            key={category.id}
                            bg="white"
                            borderRadius="xl"
                            border="1px solid"
                            borderColor="gray.100"
                            boxShadow="card"
                            p={4}
                            mb={4}
                        >
                            <Flex
                                justify="space-between"
                                align="center"
                                gap={3}
                                cursor="pointer"
                                onClick={(e) => toggleCategory(category.id, e)}
                            >
                                <Box minW={0}>
                                    <Text fontSize="lg" fontWeight="bold" color="brand.700">
                                        {category.name}
                                        {count > 0 && (
                                            <Badge
                                                as="span"
                                                ml={2}
                                                borderRadius="full"
                                                bg="red.500"
                                                color="white"
                                                px={2.5}
                                                py={0.5}
                                                fontSize="sm"
                                                verticalAlign="middle"
                                            >
                                                {count}
                                            </Badge>
                                        )}
                                    </Text>
                                    <Text fontSize="sm" color="gray.500">
                                        Obavijesti {category.notifyDaysBefore} {category.notifyDaysBefore === 1 ? "dan" : "dana"} prije isteka
                                    </Text>
                                </Box>
                                <Flex flexShrink={0} align="center" gap={2}>
                                    <IconButton
                                        icon={<FaPlus />}
                                        size="sm"
                                        className="add-icon"
                                        aria-label="Add property"
                                        onClick={() => onEdit("property", { name: "", categoryId: category.id, categoryName: category.name })}
                                    />
                                    <IconButton
                                        icon={<FaEdit />}
                                        size="sm"
                                        className="edit-icon"
                                        aria-label="Edit category"
                                        onClick={() => onEdit("category", category)}
                                    />
                                    <IconButton
                                        icon={category.isActive ? <FaEyeSlash /> : <FaEye />}
                                        size="sm"
                                        className="deactivate-icon"
                                        aria-label={category.isActive ? "Deactivate category" : "Activate category"}
                                        onClick={() => onDeactivate("category", category)}
                                    />
                                    <IconButton
                                        icon={openCategories[category.id] ? <FaChevronUp /> : <FaChevronDown />}
                                        size="sm"
                                    />
                                </Flex>
                            </Flex>

                            <Collapse in={openCategories[category.id]} animateOpacity>
                                <Box mt={3}>
                                    <PropertyList
                                        properties={category.properties}
                                        onEdit={onEdit}
                                        onDeactivate={onDeactivate}
                                    />
                                </Box>
                            </Collapse>
                        </Box>
                    );
                })
            ) : (
                <Text align="center" color="gray.500">Nema kategorija. Dodajte prvu kategoriju.</Text>
            )}
        </>
    );
};

export default memo(CategoryList);
